// Registry of ORDER snip widgets — toolId → compact dashboard widget.
// Tools without a snip widget yet get a small "Open TOOL →" card (never the
// full tool embedded; that's what onOpen / the nav drawer is for).
import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { makeThemedStyles } from '../../v10/theme';
import { GlassFill } from '../../v10/ui';
import { TOOL_NAMES } from '../../domain/olmps';
import type { OrderWidget, OrderWidgetProps } from './types';
import { AstraWidget } from './AstraWidget';
import { ClioWidget } from './ClioWidget';
import { NumaWidget } from './NumaWidget';
import { MoyriWidget } from './MoyriWidget';
import { KyrsWidget } from './KyrsWidget';
import { KrnosWidget } from './KrnosWidget';
import { TkneWidget } from './TkneWidget';
import { ThemisWidget } from './ThemisWidget';
import { MetisWidget } from './MetisWidget';

const WIDGETS: Record<string, OrderWidget> = {
  telos: AstraWidget,
  astrs: AstraWidget,
  clio: ClioWidget,
  numa: NumaWidget,
  moyri: MoyriWidget,
  kyrs: KyrsWidget,
  krnos: KrnosWidget,
  tkne: TkneWidget,
  themis: ThemisWidget,
  metis: MetisWidget,
};

function makeFallback(toolId: string): OrderWidget {
  return function FallbackWidget({ onOpen }: OrderWidgetProps) {
    const styles = useStyles();
    return (
      <Pressable style={styles.fallback} onPress={onOpen}>
        <GlassFill />
        <Text style={styles.fallbackText}>Open {TOOL_NAMES[toolId] ?? toolId.toUpperCase()} →</Text>
      </Pressable>
    );
  };
}

const fallbackCache: Record<string, OrderWidget> = {};

export function getOrderWidget(toolId: string): OrderWidget {
  if (WIDGETS[toolId]) return WIDGETS[toolId];
  if (!fallbackCache[toolId]) fallbackCache[toolId] = makeFallback(toolId);
  return fallbackCache[toolId];
}

const useStyles = makeThemedStyles(({ t }) =>
  StyleSheet.create({
    fallback: {
      borderRadius: 22,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: t.navyLine,
      paddingVertical: 16,
      alignItems: 'center',
    },
    fallbackText: { fontSize: 13, fontWeight: '700', color: t.goldBright },
  }),
);
